
import { PagamentoExtra, FuncaoService, GlobalService, Login, OrgaoAssinaturaService, Relatorio } from "eddydata-lib";
import extenso from "extenso";
import JsBarcode from "jsbarcode";

export class NotaPagamentoExtra {

  protected funcaoService: FuncaoService;
  protected globalService: GlobalService;

  private log: Login;

  private prefeito: string;
  private cargo_prefeito: string;
  private contador: string;
  private cargo_contador: string;
  private tesoureiro: string;
  private cargo_tesoureiro: string;

  constructor(protected assinaturaService: OrgaoAssinaturaService) {
    this.funcaoService = new FuncaoService();
    this.globalService = new GlobalService();
  }

  public async imprimir(model: PagamentoExtra[], login: Login) {
    this.log = login;

    // const assinatura = await this.assinaturaService.obter({
    //   orgao_id: this.log.orgao.id,
    //   'data_limite$ge': String(this.funcaoService.converteDataSQL(new Date().toLocaleDateString()))
    // }).toPromise();
    // if (assinatura) {
    //   this.prefeito = assinatura.ordenador_despesa;
    //   this.cargo_prefeito = assinatura.cargo_ordenador_despesa;

    //   this.tesoureiro = assinatura.tesoureiro;
    //   this.cargo_tesoureiro = assinatura.cargo_tesoureiro;

    //   this.contador = assinatura.contador;
    //   this.cargo_contador = assinatura.cargo_contador;
    // }


    Relatorio.imprimirPersonalizado('NOTA DE EMPENHO EXTRA', login.usuario.nome, login.usuario.sobrenome,
      login.orgao.nome, login.brasao,
      await this.montarConteudo(model),
      'portrait', 'NOTA EMPENHO EXTRA',
      {
        linhas: {
          hLineWidth() {
            return 1;
          },
          vLineWidth() {
            return 1;
          },
          hLineColor() {
            return 'black';
          },
          paddingLeft() {
            return 3;
          },
          paddingRight() {
            return 3;
          }
        }
      }, true, true);
  }

  private async montarConteudo(lista: PagamentoExtra[]) {

    const conteudo = [];

    for (const entidade of lista) {
      if (conteudo.length > 0) {
        conteudo.push([{ text: '', pageBreak: 'after' }]);
      }

      const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
      const barCode = `018170${this.funcaoService.strZero((+entidade.valor_pago).toFixed(2), 12).split('.').join('')}` +
        `${this.log.orgao.codigo.substring(0, 4)}${this.funcaoService.converteDataSQL(new Date(entidade.data_cadastro)).split('-').join('')}` +
        `${this.funcaoService.strZero(entidade.empenho.numero, 10)}${this.funcaoService.strZero(entidade.parcela, 3)}0093`;

      JsBarcode(canvas, String(barCode), { displayValue: false, height: 70, margin: 0 });

      conteudo.push(this.dadosCabecalho(this.log, entidade)
        .concat(this.dadosPagamento(entidade))
        .concat(this.dadosAplicacao(entidade))
        .concat(this.dadosConvenio(entidade))
        .concat(this.dadosFavorecido(entidade))
        .concat(this.dadosHistorico(entidade))
        .concat(await this.dadosAutorizacao(entidade))
        .concat(this.dadosRecibo()).concat([{
          image: canvas.toDataURL(),
          fit: [250, 70], margin: [10, 5]
        }]));
    }
    return conteudo;
  }

  private dadosCabecalho(log: Login, entidade: PagamentoExtra): {}[] {
    const anulacao = entidade.anulacao === true;

    let brasaoImage: {};
    if (log.brasao) {
      brasaoImage = {
        image: log.brasao,
        width: 70,
        alignment: 'center',
        margin: [0, 0, 0, 0],
        border: [true, true, true, false]
      };
    } else {
      brasaoImage = { margin: [0, 10, 0, 0], text: '', border: [true, true, true, false] };
    }

    const conteudo = [
      [brasaoImage],
      [{ text: log.orgao.nome, bold: true, alignment: 'center', fontSize: 13, border: [true, false, true, false] }],
      [{ text: `${log.orgao.endereco} ${log.cidade?.nome} ${log.cidade?.estado?.nome} CNPJ: ${log.orgao.cnpj}`, alignment: 'center', fontSize: 8, border: [true, false, true, false] }],
      [{
        text: !anulacao ? `PAGAMENTO EXTRA ORÇAMENTÁRIO - ${log.exercicio.ano}` : `ANULAÇÃO DE PAGAMENTO EXTRA ORÇAMENTÁRIO - ${log.exercicio.ano}`,
        bold: true, alignment: 'center', fontSize: 12, border: [true, false, true, false]
      }],

    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        widths: ['*'],
        body: conteudo
      }
    }];
  }

  private dadosPagamento(dados: PagamentoExtra): {}[] {
    const conteudo = [
      [
        {
          text: 'Nº ' + this.funcaoService.strZero(dados.empenho.numero, 4)
            + (dados.parcela > 0 ? '/'
              + this.funcaoService.strZero(dados.parcela, 2) : ''),
          rowSpan: 2, fontSize: 11, alignment: 'center', bold: true, margin: [0, 10, 10, 10]
        },
        { text: 'Data', fontSize: 7, border: [true, true, false, false] },
        { text: 'Prazo Pago', fontSize: 7, border: [true, true, false, false] },
        { text: 'Contrato', fontSize: 7, border: [true, true, false, false] },
        { text: 'Ficha', fontSize: 7, border: [true, true, false, false] },
        { text: 'Modalidade Licitacao', fontSize: 7, bold: true, border: [true, true, true, false], }
      ], [
        { text: '' },
        { text: this.funcaoService.converteDataBR(dados.empenho.data_empenho), alignment: 'center', bold: true, border: [false, false, false, true] },
        { text: this.funcaoService.converteDataBR(dados.empenho.data_vencimento), alignment: 'center', bold: true, border: [true, false, false, true] },
        { text: dados.empenho.contrato ? `${dados.empenho.contrato?.numero}/${dados.empenho.contrato?.ano}` : ' - ', alignment: 'center', bold: true, border: [true, false, false, true] },
        { text: dados.empenho.ficha?.numero, alignment: 'center', bold: true, border: [true, false, false, true] },
        { text: dados.empenho.contrato?.licitacao?.modalidade?.nome, alignment: 'center', bold: true, border: [true, false, true, true] }
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: [115, 60, 60, 65, 35, '*'],
        body: conteudo
      }
    }];
  }

  private dadosAplicacao(dados: PagamentoExtra): {}[] {

    const conteudo = [
      [
        { text: 'ITEM:', border: [true, false, false, false], margin: [0, 15, 0, 0] },
        { text: `${dados.empenho.ficha?.nome}`, border: [false, false, true, false], margin: [0, 15, 0, 0] },
        { text: 'VALOR TOTAL', bold: true, border: [true, false, false, false] },
        { text: this.funcaoService.convertToBrNumber(dados.valor_pago), bold: true, border: [false, false, true, false], alignment: 'right' },
      ], [
        { text: 'RECURSO:', border: [true, false, false, false], margin: [0, 15, 0, 0] },
        { text: `${dados.empenho.ficha?.recurso ? `${dados.empenho.ficha.recurso?.codigo} ${dados.empenho.ficha?.recurso?.nome}` : '-'}`, border: [false, false, false, false], margin: [0, 15, 0, 0] },
        { text: 'ANULADO', border: [true, false, false, false], bold: true, margin: [0, -15, 0, 0] },
        { text: this.funcaoService.convertToBrNumber(''), border: [false, false, true, false], bold: true, margin: [0, -15, 0, 0], alignment: 'right' },
      ], [
        { text: 'APLICAÇÃO:', border: [true, false, false, true], margin: [0, 15, 0, 15] },
        { text: `${dados.empenho.ficha?.aplicacao_variavel?.codigo ? dados.empenho.ficha?.aplicacao?.codigo + ' ' + dados.empenho.ficha?.aplicacao_variavel?.codigo : dados.empenho.ficha?.aplicacao?.codigo} ${dados.empenho.ficha?.aplicacao_variavel?.nome ? dados.empenho.ficha?.aplicacao_variavel?.nome : dados.empenho.ficha?.aplicacao?.nome}`, border: [false, false, true, true], margin: [0, 15, 0, 15] },
        { text: 'SALDO', border: [true, false, false, true], bold: true, margin: [0, -15, 0, 0] },
        { text: this.funcaoService.convertToBrNumber(''), border: [false, false, true, true], bold: true, margin: [0, -15, 0, 0], alignment: 'right' },
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: [60, '*', 60, 60],
        body: conteudo
      }
    }];
  }

  private dadosConvenio(dados: PagamentoExtra): {}[] {
    const conteudo = [
      [
        { text: 'Tipo de Meta', fontSize: 7, border: [true, false, false, false] },
        { text: 'Contrato', fontSize: 7, border: [true, false, false, false] },
        { text: 'Data Início', fontSize: 7, border: [true, false, false, false] },
        { text: 'Data Término', fontSize: 7, border: [true, false, true, false] },
        { text: 'Processo', fontSize: 7, border: [true, false, true, false] },
        { text: 'Data Assinatura', fontSize: 7, border: [true, false, true, false] }
      ], [
        { text: '', alignment: 'center', bold: true, border: [true, false, false, true] },
        { text: dados.empenho.contrato ? `${dados.empenho.contrato?.numero}` : '', alignment: 'center', border: [true, false, false, true] },
        {
          text: dados.empenho.data_empenho ? this.funcaoService.converteDataBR(dados.empenho.data_empenho) : '-',
          alignment: 'center', border: [true, false, false, true]
        },
        {
          text: dados.empenho.data_vencimento ? this.funcaoService.converteDataBR(dados.empenho.data_vencimento) : '-',
          alignment: 'center', border: [true, false, false, true]
        },
        { text: dados.empenho.processo ? dados.empenho.processo : '-', alignment: 'center', bold: true, border: [true, false, true, true] },
        {
          text: dados.empenho.contrato?.data_assinatura ? this.funcaoService.converteDataBR(dados.empenho.contrato?.data_assinatura) : '-',
          alignment: 'center', border: [true, false, true, true]
        }
      ]];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: [90, 55, 100, 65, 65, '*'],
        body: conteudo
      }
    }];
  }

  private dadosFavorecido(dados: PagamentoExtra): {}[] {
    const tipoPessoa = this.globalService.obterListaTipoFornecedores().find(x => x.id === dados.empenho.favorecido?.tipo);
    const dadosBanco = dados.empenho.favorecido.contas.filter(conta => conta.ativo === true && conta.principal === true);

    const conteudo = [
      [
        { text: 'Beneficiário:', bold: true, colSpan: 3, border: [true, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, true, false] }
      ], [
        { text: `${dados.empenho.favorecido?.nome}`, colSpan: 3, fontSize: 11, bold: true, border: [true, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: `CÓDIGO: ${dados.empenho.favorecido?.id}`, bold: true, border: [false, false, true, false] }
      ], [
        { text: 'CPF/CNPJ:', border: [true, false, false, false] },
        { text: `${dados.empenho.favorecido?.cpf_cnpj}`, border: [false, false, false, false] },
        { text: 'TIPO PESSOA:', border: [false, false, false, false] },
        { text: tipoPessoa ? tipoPessoa.nome : '-', border: [false, false, false, false] },
        { text: 'BANCO:' + (dadosBanco[0] ? dadosBanco[0].banco.nome : ''), border: [false, false, true, false] },
      ], [
        { text: 'ENDEREÇO:', border: [true, false, false, false] },
        { text: `${dados.empenho.favorecido?.endereco}, ${dados.empenho.favorecido?.num_endereco} `, border: [false, false, false, false] },
        { text: 'BAIRRO:', border: [false, false, false, false] },
        { text: dados.empenho.favorecido?.bairro, border: [false, false, false, false] },
        { text: 'AGÊNCIA:' + (dadosBanco[0] ? dadosBanco[0].agencia : ''), border: [false, false, true, false] },
      ], [
        { text: 'CIDADE:', border: [true, false, false, true] },
        { text: `${dados.empenho.favorecido?.municipio}, ${dados.empenho.favorecido?.uf} `, border: [false, false, false, true] },
        { text: 'TELEFONE:', border: [false, false, false, true] },
        { text: dados.empenho.favorecido?.telefone ? `(${dados.empenho.favorecido?.ddd_fone ? dados.empenho.favorecido?.ddd_fone : ''}) ${dados.empenho.favorecido?.telefone}` : ' - ', border: [false, false, false, true] },
        { text: 'Nº CONTA:' + (dadosBanco[0] ? dadosBanco[0].numero_conta : ''), border: [false, false, true, true] },
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        widths: [60, '*', 60, 150, '*'],
        body: conteudo
      }
    }];
  }

  private dadosHistorico(dados: PagamentoExtra): {}[] {
    const conteudo = [
      [
        { text: 'Histórico:', border: [true, false, true, false], bold: true },
        { text: 'Observações', border: [false, false, true, false], colSpan: 2 },
        {}
      ], [
        { text: `${dados.historico} - ${dados.empenho.retencao?.liquidacao?.empenho?.favorecido?.cpf_cnpj ? dados.empenho.retencao?.liquidacao?.empenho?.favorecido?.cpf_cnpj : ''} - Documento Fiscal nº ${dados.empenho.retencao?.liquidacao?.documento ? dados.empenho.retencao?.liquidacao?.documento : ''}`, border: [true, false, true, false] },
        { text: ``, border: [false, false, true, true], colSpan: 2 },
        {}
      ], [
        { text: '', border: [true, false, false, true] },
        { text: 'VALOR...', border: [true, true, false, true], bold: true, fontSize: 11 },
        { text: this.funcaoService.convertToBrNumber(dados.empenho.valor_empenho), border: [false, true, true, true], bold: true, fontSize: 11, alignment: 'right' }
      ], [
        { text: 'Fica empenhado a importância de:', bold: true, border: [true, true, true, false], colSpan: 3 },
        {},
        {}
      ], [
        {
          text: extenso(this.funcaoService.convertToBrNumber(dados.empenho.valor_empenho), { mode: 'currency', currency: { type: 'BRL' } }).toUpperCase(),
          border: [true, false, true, false], colSpan: 3
        },
        {},
        {}
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        heights: [15, 80, 15, 15, 30],
        widths: [280, '*', '*'],
        body: conteudo
      }
    }];
  }

  private async dadosAutorizacao(dados: PagamentoExtra): Promise<{}[]> {

    const assinatura = await this.assinaturaService.obter({
      orgao_id: this.log.orgao.id,
      'data_limite$ge': String(this.funcaoService.converteDataSQL(new Date(dados.data_pagamento))),
      orderBy: 'data_limite'
    }).toPromise();
    if (assinatura) {
      this.prefeito = assinatura.ordenador_despesa;
      this.cargo_prefeito = assinatura.cargo_ordenador_despesa;

      this.tesoureiro = assinatura.tesoureiro;
      this.cargo_tesoureiro = assinatura.cargo_tesoureiro;

      this.contador = assinatura.contador;
      this.cargo_contador = assinatura.cargo_contador;
    }

    const conteudo = [
      [
        { text: 'AUTORIZAÇÃO CONTABILIZAÇÃO', bold: true, border: [true, true, true, false], margin: [0, 0, 0, 10] },
        { text: 'AUTORIZAÇÃO EMPENHO', bold: true, border: [false, true, true, false] },
        { text: 'AUTORIZAÇÃO PAGAMENTO', bold: true, border: [false, true, true, false], colSpan: 2 },
        {}
      ], [
        { text: '___________________________________', alignment: 'center', border: [true, false, true, false] },
        { text: '___________________________________', alignment: 'center', border: [false, false, true, false] },
        { text: '___________________________________', alignment: 'center', border: [false, false, false, false] },
        { text: '___________________________________', alignment: 'center', border: [false, false, true, false] },
      ], [
        { text: this.contador ? this.contador : '', fontSize: 7, alignment: 'center', border: [true, false, true, false] },
        { text: this.prefeito ? this.prefeito : '', fontSize: 7, alignment: 'center', border: [false, false, true, false] },
        { text: this.tesoureiro ? this.tesoureiro : '', fontSize: 7, alignment: 'center', border: [false, false, false, false] },
        { text: this.prefeito ? this.prefeito : '', fontSize: 7, alignment: 'center', border: [false, false, true, false] },
      ], [
        { text: this.cargo_contador ? this.cargo_contador : '', fontSize: 7, alignment: 'center', border: [true, false, false, false] },
        { text: this.cargo_prefeito ? this.cargo_prefeito : '', fontSize: 7, alignment: 'center', border: [true, false, true, false] },
        { text: this.cargo_tesoureiro ? this.cargo_tesoureiro : '', fontSize: 7, alignment: 'center', border: [false, false, false, false] },
        { text: this.cargo_prefeito ? this.cargo_prefeito : '', fontSize: 7, alignment: 'center', border: [false, false, true, false] },
      ], [
        { text: 'Data: _____/_____/________', border: [true, false, true, true] },
        { text: 'Data: _____/_____/________', border: [true, false, true, true] },
        { text: 'Data: _____/_____/________', border: [true, false, true, true], colSpan: 2 },
        {}
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        heights: [30, 10, 5, 30],
        widths: ['*', '*', '*', '*'],
        body: conteudo
      }
    }];
  }


  private dadosRecibo(): {}[] {
    const conteudo = [
      [
        { text: 'RECIBO E QUITAÇÃO', border: [true, false, false, false], colSpan: 2 },
        { text: '', border: [false, false, false, false], },
        { text: '', border: [false, false, false, false], },
        { text: '', border: [false, false, true, false], }
      ], [
        { text: 'Recebemos o valor a que se refere este empenho, ao qual damos plena e geral quitação.', border: [true, false, false, false], colSpan: 2, margin: [0, 0, 20, 0] },
        { text: '', border: [false, false, false, false], },
        { text: 'Assinatura', border: [false, false, false, false], },
        { text: 'Documento', border: [false, false, true, false], }
      ], [
        { text: 'Data: _____/_____/________', border: [true, false, false, true], colSpan: 2 },
        { text: '', border: [false, false, false, true], },
        { text: '__________________________', border: [false, false, false, true], },
        { text: '__________________________', border: [false, false, true, true], }
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        heights: [10, 0],
        widths: ['*', '*', '*', '*'],
        body: conteudo
      }
    }];
  }

}
